import { putApi } from '../../../utils/api'

export function updateSearchResultsInhabitantsTableConfig(data) {
  return putApi({
    data,
    endpoint: 'idwell-api/api/v3/table/tables/inhabitants-search/config/',
  })
}
